var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReadonlyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10,
    r: 9.25,
    stroke: "#949494",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#949494",
    d: "m9.944 12.312-.012-.276a49.247 49.247 0 0 1-.096-2.844V5.844h1.32v3.348c0 .72-.024 1.56-.072 2.52l-.024.6H9.944Zm.564 2.82a.82.82 0 0 1-.6-.252.82.82 0 0 1-.252-.6c0-.224.084-.416.252-.576a.84.84 0 0 1 .6-.24c.216 0 .404.08.564.24.168.16.252.352.252.576a.84.84 0 0 1-.24.6.767.767 0 0 1-.576.252Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadonlyIcon);
export default __webpack_public_path__ + "static/media/readonly_icon.742e5c95c6f26a26fb70e9359f45aa9c.svg";
export { ForwardRef as ReactComponent };